import logo from "../../assets/logo.png";

const Logo = () => {
  return (
    <div className="flex w-full">
      <img src={logo} alt="INTEREX" className="w-52 ml-auto mr-auto" />
    </div>
  );
};
export default Logo;
